/** @format */

import {Text} from 'recharts';

import {PointName} from 'components/charts/multiline-chart/model/common';
import {XAxisDataList} from 'components/charts/multiline-chart/model/xAxis';

interface XAxisLabelPropsWithTick extends XAxisLabelProps {
  payload: {value: PointName};
  x: number;
  y: number;
}

interface XAxisLabelProps {
  xAxisDataList: XAxisDataList;
}

const CustomXAxisLabel = (props: XAxisLabelPropsWithTick) => {
  const {
    payload: {value},
    xAxisDataList,
  } = props;

  const data = xAxisDataList[value];

  if (!data) {
    return null;
  }

  const {label, color} = data;

  return (
    <g>
      <Text {...props} y={28} fill={color ? color : '#FAFBFE'} fontSize={14}>
        {label}
      </Text>
    </g>
  );
};

export default CustomXAxisLabel;
